import React from 'react';
import InputWrapper from './InputWrapper';

const NumericInput = ({ min = 0, max = 99, field, fieldId, value, onChange, label, isRequired, error }) => {
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <input
        type="number"
        className="profile-input form-input"
        value={value}
        onChange={e => onChange(fieldId, parseInt(e.target.value) || 0)}
        min={field.min}
        max={field.max}
        step="1"
        disabled={field.readOnly || false}
      />
    </InputWrapper>
  );
};

export default NumericInput;

